/**
 * メールアドレスの形式を簡易的に判定する。
 * 「メールアドレス認証」ボタンの活性・非活性の判定に使う (JPTP_CANSEI-1258)。
 */
export function isValidEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}
